import { useEffect, useState } from 'react';
import { createShortLivedToken } from '../services/vault/token';
import { extractErrorMessage } from '../util/errorMessage';

export default function useShortLivedToken(): {
  shortLivedToken?: string;
  errorMessage?: string;
} {
  const [shortLivedToken, setShortLivedToken] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    const getToken = async (): Promise<void> => {
      try {
        const token = await createShortLivedToken();
        setShortLivedToken(token);
      } catch (e) {
        setErrorMessage(extractErrorMessage(e));
      }
    };
    getToken();
  }, []);

  return { shortLivedToken, errorMessage };
}
